export default __webpack_public_path__ + "static/abb-aa4001c228c5dcda28080681713ba49a.png";